import { input, computed, Component, viewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SvgIcon } from '@shared/ui/svg-icon';
import { IconButton } from '@shared/ui/icon-button';
import { Menu, type MenuItem } from '@shared/ui/menu';

import { type EntityAction, resolveEntityActions } from '@shared/utils/entity-actions';

@Component({
  selector: 'app-table-row-actions-button',
  imports: [IconButton, SvgIcon, Menu],
  templateUrl: './table-row-actions-button.html',
  styleUrl: './table-row-actions-button.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableRowActionsButton<T> {
  public readonly item = input.required<T>();
  public readonly actions = input<EntityAction<T>[]>([]);

  private readonly menuRef = viewChild.required(Menu);

  protected readonly resolvedActions = computed<MenuItem[]>(() => resolveEntityActions(this.actions(), this.item()));

  protected readonly hasActiveItems = computed(() =>
    this.resolvedActions().some((action) => action.visible !== false && !action.disabled),
  );

  protected toggle(event: MouseEvent): void {
    if (!this.hasActiveItems()) {
      return;
    }

    this.menuRef().toggle(event);
  }
}
